import { GetStaticProps } from 'next'

import { NewtClient } from '@/utils/NewtClient'

export { DividendPage as default } from '@/components/enpages/Ir/Stock/DividendLatest'

export const getStaticProps: GetStaticProps = async () => {
  const client = new NewtClient()

  const items = await client.fetchStockDividend()
  return {
    props: {
      items,
    },
  }
}
